module.exports = __webpack_public_path__ + "static/img/monitorando.61015ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/thumbnails/projects/monitorando.jpg
// module id = 5UMh
// module chunks = 0